exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invite-tabs{font-size:.8rem}.invite-tabs .nav-tabs,.invite-tabs .tab-content{max-height:200px;max-width:100%;flex-wrap:nowrap}.invite-tabs .nav-link{text-transform:capitalize}.check-block-member-info{color:#6c757d;font-size:14px}", ""]);

// exports
